import * as React from 'react';

export default function CalendarIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 22" fill="none" {...props}>
      <path
        d="M.86 8.154h17.824M14.21 12.06h.009M9.772 12.06h.01M5.326 12.06h.009M14.21 15.946h.009M9.772 15.946h.01M5.326 15.946h.009M13.812.75v3.29M5.733.75v3.29"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M14.006 2.33H5.539C2.602 2.33.768 3.964.768 6.971v9.05c0 3.054 1.834 4.728 4.77 4.728h8.459c2.945 0 4.77-1.645 4.77-4.653V6.972c.01-3.007-1.815-4.643-4.761-4.643z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
